import React, { useState, useEffect } from 'react';
import '../../../entrydoor.css';
import ImageModal from '../../../components/ImageModal';

const TopRowConf = ({ value, onChange, id='TopRowConf', label = 'Top Row Configuration', disabled = false, showPics = false, disabledOptions = [] }) => {
    const [selectedTopRowConf, setSelectedTopRowConf] = useState(value || "");
    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
        setSelectedTopRowConf(value || "");
    }, [value]);

    const handleTopRowConfChange = (e) => {
        setSelectedTopRowConf(e.target.value);
        onChange(e.target.value);
    };

    const isOptionDisabled = (optionValue) => {
        return disabledOptions.includes(optionValue);
    };

    return (
        <div className="a-container">
            <label
                disabled={disabled}
                htmlFor="TopRowConf"
                onClick={() => showPics && setShowModal(true)}
                style={{ cursor: showPics ? 'pointer' : 'default' }}
            >
                {label}
            </label>
            <select
                disabled={disabled}
                id={id}
                value={selectedTopRowConf}
                onChange={handleTopRowConfChange}
            >
                <option value="" disabled hidden>Select an option</option>
                <option value="None" disabled={isOptionDisabled("None")}>{selectedTopRowConf === "None" ? "None ✔" : "None"}</option>
                <option value="1" disabled={isOptionDisabled("1")}>{selectedTopRowConf === "1" ? "1 Section ✔" : "1 Section"}</option>
                <option value="Grid" disabled={isOptionDisabled("Grid")}>{selectedTopRowConf === "Grid" ? "Grid ✔" : "Grid"}</option>
                <option value="Arch" disabled={isOptionDisabled("Arch")}>{selectedTopRowConf === "Arch" ? "Arch ✔" : "Arch"}</option>
                <option value="ArchGrid" disabled={isOptionDisabled("ArchGrid")}>{selectedTopRowConf === "ArchGrid" ? "ArchGrid ✔" : "ArchGrid"}</option>
                <option value="ArchBar" disabled={isOptionDisabled("ArchBar")}>{selectedTopRowConf === "ArchBar" ? "Arch with Horizontal Bar ✔" : "Arch  with Horizontal Bar"}</option>


            </select>
            <ImageModal
                isOpen={showModal}
                onClose={() => setShowModal(false)}
                folder="images/TopRowConf"
                imageName={selectedTopRowConf}
                width={200}  //optional
                height={250} //optional
            />
        </div>
    );
};

export default TopRowConf;
